import "./userProfile.scss";
import AuthClient from "../../api/AuthClient";
import { iconsImgs } from "../../utils/icons";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import ModalImgInput from "./ModalImgInput";
import Header from "../Header";
import GetUserProfileInfoApi from "../../api/GetUserProfileInfoApi";
import { parseUserProfileInfo } from "../../api/parseResponse/parseUserProfileInfo";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { getUserAvatar } from "../../utils/getMedia";
import { routes } from "../../routes/routes";
import { CurrentPathContext } from "../../GlobalContext/currentPathContext";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import handleImgError from "../../handleImgError";
import { CitiesInfoContext } from "../../AllCitiesContext";
import { UserProfileInfoContext } from "../../GlobalContext/UserProfileInfoContext";
import AddOrSetPhotoAsProfileApi from "../../api/AddOrSetPhotoAsProfileApi";
import { uploadUserProfileImage } from "../../azureBlob/BlobStorageService";

const UserProfile = () => {

  const [showModal, setShowModal] = useState(false);
  const [showAddImageConfirmation, setShowAddImageConfirmation] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const navigate = useNavigate();
  const handleEditProfileClick = () => {
    navigate('/edit-profile');
  };

  const { userProfileInfo, setUserProfileInfoContextData, setUserProfileFieldValues } = useContext(UserProfileInfoContext);
  const { currentPath, setCurrentPath } = useContext(CurrentPathContext);
  const { citiesInfo } = useContext(CitiesInfoContext);

  const userInfo = userProfileInfo?.[0];
  const allCities = citiesInfo[0]?.allCities;
  const filteredCity =
    allCities?.filter((city) => city.Id === userInfo?.CityId) ?? [];
  const profileImageUrl = userInfo ? getUserAvatar(`${userInfo.Id}T?${Date.now()}`) : "";

  const cityName = filteredCity[0]?.Name;
  const location = useLocation();

  useEffect(() => {
    const authClient = new AuthClient();
    const userProfileInfoApi = new GetUserProfileInfoApi(authClient);

    try {
      userProfileInfoApi.getUserProfileInfo().then((response) => {
        if (response?.data) {

          const parsedData = parseUserProfileInfo(response.data.profileInfo);

          setUserProfileInfoContextData([parsedData.userProfileInfo]);
        }
      });

    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  }, []);

  const addOrSetPhotoAsProfile = () => {
    handleShowModal();
  }

  const handleImageSelected = (file: File) => {
    setSelectedImageFile(file);
    setShowAddImageConfirmation(true);
  };

  const handleImageUpload = async (setAsProfilePhoto: boolean) => {
    if (!selectedImageFile || !userInfo) {
      return;
    }

    setShowAddImageConfirmation(false);

    const authClient = new AuthClient();
    const updatedImgCount = await uploadUserProfileImage({
      authClient,
      file: selectedImageFile,
      profileId: userInfo.Id,
      profileCount: userInfo.CountProfilePictures,
      setAsProfilePhoto,
    });

    const addImageApi = new AddOrSetPhotoAsProfileApi(authClient);
    addImageApi.addImageOrSetPhotoAsProfile(updatedImgCount, setAsProfilePhoto).then(() => {
      if (!setAsProfilePhoto) {
        setUserProfileFieldValues(userInfo.Id, { CountProfilePictures: updatedImgCount });
      }
      setSelectedImageFile(null);
    }).catch((error) => {
      console.log(error)
    });
  };

  useEffect(() => {
    const handleBackButton = () => {
      try {
        if (currentPath === routes.UserProfile) {
          console.log("Popped from userprofile"); //Debug log
          // navigate(routes.Root);
          window.removeEventListener('popstate', handleBackButton);
        }
      } catch (error) {
        console.log('Error handling back navigation:', error);
      }
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      if (window.location.pathname !== '/rapp/user-profile') {
        window.removeEventListener('popstate', handleBackButton);
      }
    };
  }, [location.pathname]);

  return (
    <div className="userProfilePage">
      <Header />
      {userInfo &&

        <div className="centerGroup">
          <div className="desktopUI">
            <div className="row userProfile_Header">
              <div className="d-flex justify-content-start space col-6 userProfileBackOverlay">
                <button
                  className="BtnTop yellowTxt btn text-decoration-none backBtn"
                  onClick={() => navigate(routes.Root)}
                >
                  Back
                </button>
              </div>

              <div className="d-flex justify-content-end space col-6 userProfileEditOverlay">
                <button className="BtnTop yellowTxt btn text-decoration-none" onClick={handleEditProfileClick} >
                  Edit Profile
                </button>
              </div>
            </div>

            <div className=" p-0  text-white">
              <h2 className="m-0 mt-2 p-0">
                {userInfo?.FirstName} {userInfo?.LastName}
              </h2>
              <span className="m-0  p-0">{cityName}</span>
              <div className="mt-3 ">
                <img
                  src={profileImageUrl}
                  alt={`${userInfo?.FirstName} ${userInfo?.LastName}`}
                  className="UserProfileImg"
                  onError={(event) => handleImgError(event, userInfo.Gender.toString())}

                />
              </div>
              <div className="d-flex m-3 ">
                <span
                  className="m-0 p-0 addImage yellowTxt"
                  onClick={addOrSetPhotoAsProfile}
                >
                  + Add Image
                </span>
              </div>
              <ModalImgInput showModal={showModal} handleCloseModal={handleCloseModal} onImageSelected={handleImageSelected} />
              <Modal backdrop={false} centered show={showAddImageConfirmation} onHide={() => setShowAddImageConfirmation(false)}>
                <Modal.Body className="text-center">
                  Set new photo as profile photo?
                </Modal.Body>
                <Modal.Footer>
                  <button className="link btns btnMO justify-content-center d-flex mt-3 align-content-center p-3 m-3" onClick={() => handleImageUpload(false)} >
                    No
                  </button>
                  <button className="link btns btnMO justify-content-center d-flex mt-3 align-content-center p-3 m-3" onClick={() => handleImageUpload(true)} >
                    Yes
                  </button>
                </Modal.Footer>
              </Modal>
              {/* Here goes the modal  */}
            </div>

            <div className="container">
              <img src={iconsImgs.Image} className="iconImage d-flex" alt="Icon Image" />
              <div className="iconImg ">
                {userInfo.CountProfilePictures > 0 && Array.from({ length: userInfo.CountProfilePictures }, (_, i) => (
                  <Link
                    onClick={() => { setCurrentPath(window.location.pathname) }}
                    to={routes.PhotoZoom("user-profile", "0", userInfo.Id, `${i + 1}?photo=${`${userInfo?.Id!}${i + 1}`}`)}
                    key={i + 1}
                    className="img-link"
                  >
                    <img
                      key={i + 1}
                      src={getUserAvatar(`${userInfo.Id!}${i + 1}?${Date.now()}`)}
                      alt={`image${i + 1}`}
                      style={{ pointerEvents: 'all' }}
                      className="ImgOptions ms-3"
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default UserProfile;
